<template>
    <div>
        <h3 v-translate>Add new activity</h3>
        <input-field label="Step name" type="text" :field="$v.activity.name"/>

        <div class="message message--with-icon message--info" v-translate>You will later define each step in details.</div>
        <div class="form__action-buttons form__action-buttons--inline">
            <button @click="submit()" class="button button--primary" type="submit" v-translate>Add activity</button>
            <!--<button class="button button--transparent">Close</button>-->
        </div>
    </div>
</template>
<script>
    import InputField from "./popups/InputField";
    import {required} from 'vuelidate/lib/validators';

    function getDefaultData() {
        return {
            activity: {
                name: '',
                description: '',
                category: '',
                subcategory: '',
                expected_result: '',
                measure: '',
                date: '',
                strength: null,
            }
        }
    }

    export default {
        components: {InputField},
        name: 'add-activity-step',
        data: getDefaultData,
        validations: {
            activity: {
                name: {required}
            }
        },
        methods: {
            resetData: function () {
                this.$data = getDefaultData();
            },
            submit: function() {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.$emit('add', this.activity)
                    this.activity = getDefaultData().activity
                    this.$v.$reset();
                }
            }
        }
    }
</script>